import { BaseRepository } from "@/repositories/base-repository"
import { type IOrder } from "@/interfaces/api/order.interface"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"

export class OrderRepository extends BaseRepository<IOrder> {
  protected resourcePath = "planning/orders"

  public async mergeOrders(orders: Array<IOrder>) {
    return await new HTTPRequestBuilder(HTTPMethods.POST, `${this.resourcePath}/merge/`)
      .setData(orders)
      .build()
      .execute()
  }
}
